export default __webpack_public_path__ + "static/media/07_photo.a7418b27.jpg";